export default function millerStability (twistRate, diameter, length, grains, velocity, temperature, altitude) {
  let correction = 1
  if (velocity) {
    correction = Math.pow(velocity / 2800, .3333333)
  }
  if (altitude) {
    correction = correction * Math.pow(Math.E, 3.158e-5 * altitude)
  }
  length /= diameter
  twistRate /= diameter
  const sg = correction * (
    (30 * grains) /
    (twistRate ** 2 * diameter ** 3 * length * (1 + length ** 2))
  )
  return sg
}
